import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=063605c4&scoped=true&lang=html&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=063605c4&lang=scss&scoped=true&"
import style1 from "./Modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063605c4",
  null
  
)

export default component.exports